// CRM C-I: Vorlagen, Textbausteine und Signaturen.
//
// Auflisten ohne Scan — zwei Index-Abfragen, im Frontend als „meine" / „global"
// gruppiert. Der Index ist trotz der Owner-Regel nötig: die Regel erzeugt einen
// `authFilter`, und der greift NACH dem Seitenlesen. Ohne Index wäre jede Abfrage ein
// gefilterter Scan.
//
// `bySharedBase` ist SPARSE: `sharedBase` ist nur bei globalen Vorlagen gesetzt,
// persönliche fallen komplett aus dem Index heraus. Kein Filter, kein Scan.

export const emailTemplatesByCreatedBy = /* GraphQL */ `
  query EmailTemplatesByCreatedBy($createdBy: ID!, $nextToken: String) {
    emailTemplatesByCreatedBy(createdBy: $createdBy, limit: 200, nextToken: $nextToken) {
      items {
        id
        type
        name
        subject
        body
        isPrimary
        sharedBase
        createdAt
      }
      nextToken
    }
  }
`;

export const emailTemplatesBySharedBase = /* GraphQL */ `
  query EmailTemplatesBySharedBase($sharedBase: String!, $nextToken: String) {
    emailTemplatesBySharedBase(sharedBase: $sharedBase, limit: 200, nextToken: $nextToken) {
      items {
        id
        type
        name
        subject
        body
        isPrimary
        createdBy
        sharedBase
        createdAt
      }
      nextToken
    }
  }
`;

// Beim Anlegen muss das Frontend `createdBy` auf die eigene `sub` setzen: bei einem
// abweichenden `ownerField` füllt Amplify das nicht selbst, der Resolver prüft es nur.
// Ohne diese Zeile gehört die Vorlage niemandem und ist danach unerreichbar.
export const createEmailTemplates = /* GraphQL */ `
  mutation CreateEmailTemplates($input: CreateEmailTemplatesInput!) {
    createEmailTemplates(input: $input) {
      id
      type
      name
      subject
      body
      isPrimary
      createdAt
    }
  }
`;

export const updateEmailTemplates = /* GraphQL */ `
  mutation UpdateEmailTemplates($input: UpdateEmailTemplatesInput!) {
    updateEmailTemplates(input: $input) {
      id
      type
      name
      subject
      body
      isPrimary
    }
  }
`;

export const deleteEmailTemplates = /* GraphQL */ `
  mutation DeleteEmailTemplates($input: DeleteEmailTemplatesInput!) {
    deleteEmailTemplates(input: $input) {
      id
    }
  }
`;
